<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="vx-row" v-bind:class="[mobileSc ? 'text-center' : '']">
      <!--  -->
      <!-- USER PRODFILE CARD -->
      <div class="vx-col w-full lg:w-2/3 sm:w-1/2 mb-base">
        <vx-card title="ยอดเงินกู้ (เงินต้น)">
          <!-- <template slot="actions">
            <span class="label">ข้อมูล ณ วันที่ : 04 ส.ค. 2564 13:15 น.</span>
          </template> -->
          <div class="vx-row">
            <div class="vx-col lg:w-1/4 sm:w-full">
              <vue-apex-charts type="donut" height="auto" class="w-full" :options="principleRemainPie.chartOptions" :series="principleRemainData.series" />
            </div>
            <div class="vx-col lg:w-3/4 sm:w-full">
              <div class="vx-row mb-2">
                <div class="vx-col lg:w-3/5 w-full">
                  <span class="label cursor-pointer">ยอดเงินต้นคงเหลือ</span><br>
                  <span class="principleRemain">{{ principleRemain | numberFormat }}</span><span class="moneyUnit"> บาท</span><br>
                  <!-- <span class="label">จากยอดเงินกู้ </span> <span class="bold">{{ loanAmount | numberFormat }}</span> <span class="moneyUnit"> บาท</span><br> -->
                  <hr v-if="mobileSc" class="mb-3 mt-3">
                </div>
                <div class="vx-col lg:w-2/5 w-full">
                  <span class="label">ชำระไปแล้ว</span><br>
                  <span class="paidPrinciple">{{ paidPrinciplePercentage }}%</span><br>
                  <span class="label">จำนวนเงิน </span> <span class="bold">{{ paidPrinciple | numberFormat }}</span> <span class="moneyUnit"> บาท</span><br>
                  <span class="label">*ยอดเงินต้นที่ชำระแล้ว</span><br>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col lg:w-full">
                  <vs-alert>ชำระเงินครั้งล่าสุด : {{ lastPaymentDate }}  เป็นจำนวนเงิน : {{ lastPaymentAmount | numberFormat }} บาท</vs-alert>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <!-- USER PRODFILE CARD -->
      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-if="!overDue">
          <vx-card title="ยอดรวมที่ต้องชำระ"><br>
            <span class="paymentAmount">{{ paymentAmount | numberFormat }}</span><span class="moneyUnit"> บาท</span><br>
            <span class="label">ชำระภายใน </span><span class="bold">{{ paymentRoundDate }}</span><br>
            <vs-button class="w-full mt-8" color="primary" type="filled" @click="btnPayment()">ชำระเงิน</vs-button>
          </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" v-if="overDue">
          <vx-card title="ยอดชำระเพื่อปิดบัญชี"><br>
            <span class="paymentAmount">{{ paymentAmount | numberFormat }}</span><span class="moneyUnit"> บาท</span><br>
            <span class="label">วันครบกำหนดชำระงวดสุดท้าย </span><span class="bold">{{ paymentRoundDate }}</span><br>
            <vs-button class="w-full mt-8" color="primary" type="filled" @click="btnPayment()">ชำระเงิน</vs-button>
          </vx-card>
      </div>
    </div>
    <div class="vx-row">
        <!-- USER PRODFILE CARD -->
       <div class="vx-col w-full lg:w-full mb-base" v-if="!mobileSc" >
          <vx-card title="รายการบัญชี">
            <vs-table :data="transactions">

              <template slot="thead">
                <vs-th>วันที่ทำรายการ</vs-th>
                <vs-th>ประเภทรายการ</vs-th>
                <vs-th class="bold">ยอดเงิน</vs-th>
                <vs-th class="text-right">ยอดเงินกู้คงเหลือ (เงินต้น)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="index" v-for="(transaction, index) in data">

                  <vs-td>
                    <span class="bold">{{ transactionDate(transaction) }}</span><br>
                    <span>{{ transactionTime(transaction) }}</span>
                  </vs-td>

                  <vs-td>
                    <span class="bold">{{ transactionType(transaction) }}</span>
                  </vs-td>

                  <vs-td>
                    <span class="bold cursor-pointer" v-if="transaction.transactionType === 'AddPayment'"><a>{{ amount(transaction) | numberFormat }}</a></span>
                    <!-- @click="btnTransactionPayment(transaction.id)" -->
                    <span class="bold" v-if="transaction.transactionType !== 'AddPayment'">{{ amount(transaction) | numberFormat }}</span><br>
                    <span>บาท</span>
                  </vs-td>

                  <vs-td>
                    <span class="bold">{{ transaction.principleRemain | numberFormat }}</span><br>
                    <span>บาท</span>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <div v-if="transactions.length >= 3">
              <vs-alert active="true" color="#8389a2">
                <div class="more cursor-pointer text-center" @click="btnMore()" >
                  <span color="#8389a2">ดูเพิ่มเติม</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
                </div>
              </vs-alert>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full lg:w-full mb-base list-card" v-if="mobileSc" >
          <vx-card>
            <div :key="index" v-for="(transaction, index) in transactions">
              <span class="title-head">{{ transactionType(transaction) }}</span>
                <div class="vx-row">
                  <div class="vx-col w-full flex">
                    <span class="label text-left">วันที่ทำรายการ</span>
                    <vs-spacer />
                    <span class="text-right">
                      <span class="bold">{{ transactionDate(transaction) }} {{ transactionTime(transaction) }}</span>
                    </span>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full flex">
                    <span class="label text-left">ยอดเงิน (บาท)</span>
                    <vs-spacer />
                    <span class="text-right">
                      <span class="bold cursor-pointer" v-if="transaction.transactionType === 'AddPayment'"><a>{{ amount(transaction) | numberFormat }}</a></span>
                      <!-- @click="btnTransactionPayment(transaction.id)" -->
                      <span class="bold" v-if="transaction.transactionType !== 'AddPayment'">{{ amount(transaction) | numberFormat }}</span><br>
                    </span>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full flex">
                    <span class="label text-left">ยอดเงินกู้คงเหลือ (บาท)</span>
                    <vs-spacer />
                    <span class="bold text-right">{{ transaction.principleRemain | numberFormat }}</span>
                  </div>
                </div>
                <hr v-if="index < (transactions.length - 1)" class="mb-5">
            </div>
            <div v-if="transactions.length >= 3">
                <vs-alert active="true" color="#8389a2">
                  <div class="more cursor-pointer text-center" @click="btnMore()" >
                    <span color="#8389a2">ดูเพิ่มเติม</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
                  </div>
                </vs-alert>
              </div>
          </vx-card>
        </div>
    </div>
    <vs-prompt v-if="!isStudentSupportReadOnly"
      @accept="acceptPrompt"
      title="ตรวจสอบข้อมูล"
      :is-valid="validEmail && validPrompt"
      :active.sync="prompt.active">
      <div class="con-exemple-prompt">
        กรุณาตรวจสอบข้อมูลอีเมลและเบอร์มือถือของท่าน <b>เพื่อดำเนินการต่อ</b>
      <vs-input placeholder="อีเมล" v-model="prompt.email" class="mt-4 mb-2 w-full" />
      <vs-input placeholder="เบอร์มือถือ" v-model="prompt.mobile" class="w-full" />
      <vs-alert :active="!validEmail" color="danger" vs-icon="new_releases" class="mt-1">
        กรุณาตรวจสอบรูปแบบอีกเมล
      </vs-alert>
      <vs-alert :active="!validPrompt" color="danger" vs-icon="new_releases" class="mt-1">
        กรุณากรอกข้อมูลให้ครบถ้วน
      </vs-alert>

      </div>
    </vs-prompt>
    <vs-popup title="รายละเอียดการชำระ" :active.sync="transactionPaymentPopup.active">
      <div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">ค่าธรรมเนียม</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidFee | numberFormat }}</span>
        </div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">เบี้ยปรับ</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidPenalty | numberFormat }}</span>
        </div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">ดอกเบี้ย</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidInterest | numberFormat }}</span>
        </div>
        <div class="vx-row flex">
          <span class="vx-col flex-1 text-left label">เงินต้น</span>
          <span class="vx-col flex-1 text-right label-bold">{{ transactionPaymentPopup.paidPrinciple | numberFormat }}</span>
        </div><br>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'
import { round, paidTransactionDetail, isEmpty } from '@/utils'
import colors from '@/constants/colors'
import {IPaymentAmountDetailType} from "@/constants/interface";

const moment = require('moment');
const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  components: {
    VueApexCharts,
    StatisticsCardLine
  },
  data () {
    return {
      principleRemainPie: {
        chartOptions: {
          labels: ['ชำระแล้ว', 'เงินต้นคงเหลือ'],
          dataLabels: {
            enabled: false
          },
          legend: { show: false },
          chart: {
            type: 'pie',
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          stroke: {
            width: 5
          },
          colors: [ colors.success, colors.primary]
        }
      },
      principleRemainData: {
        analyticsData: [],
        series: []
      },
      transactionPaymentPopup: {
        active: false,
        paidFee: 0,
        paidPenalty: 0,
        paidInterest: 0,
        paidPrinciple: 0,
      },
      prompt:{
        active: false,
        email: "",
        mobile: ""
      },
    }
  },
  async created() {
    const vm = this
    const { getContractsByCurrentUser, getTransactionsActionByContractId, getDashboardDetailByContractId, getPaymentAmountDetailByContractId, getPaymentRoundDetailByContractId } = vm
    if(!vm.isStudentSupportReadOnly && vm.$store.state.currentUser.updateInformation === false){
      vm.prompt = {
        active: true,
        email: vm.$store.state.currentUser.profile.email,
        mobile: vm.$store.state.currentUser.profile.mobile,
      }
    }
    if(isEmpty(vm.contract)){
      await getContractsByCurrentUser()
    }
    await getTransactionsActionByContractId({
      form: {
        contractId: vm.contract.id,
        filters: {
          limit: 3,
          action: 'All',
          year: 0
        }
      }
    });
    await getDashboardDetailByContractId({form: {contractId: vm.contract.id}});
    await getPaymentAmountDetailByContractId({form: {contractId: vm.contract.id, type: IPaymentAmountDetailType.normal, amount: 0}});
    await getPaymentRoundDetailByContractId({form: {contractId: vm.contract.id}});
    setTimeout(() => {
      vm.principleRemainData = {
        analyticsData: [
          {
            'type': 'เงินต้นคงเหลือ',
            'amount': vm.principleRemain,
            'color': colors.primary
          },{
            'type': 'ชำระแล้ว',
            'amount': vm.paidPrinciple,
            'color': colors.success
          }
        ],
        series: [vm.paidPrinciple, vm.principleRemain]
      }
    }, 100);
  },
  computed: {
    ...mapAccountingState(['status', 'contract', 'loan', 'contracts', 'loanDetails', 'restructuringDetail', 'transactions', 'paymentAmountDetailNormal', 'paymentRoundDetail', 'dashboardDetail']),
    overDue() {
      return this.contract.loan.isOverDue;
    },
    mobileSc () {
      if(this.$store.state.windowWidth < 480) return true
      return false
    },
    loanAmount(){
      if (!this.dashboardDetail || !this.dashboardDetail.summaryDetail) return 0.00
      return round(this.dashboardDetail.summaryDetail.loanAmount, 2)
    },
    principleRemain() {
      if (!this.dashboardDetail || !this.dashboardDetail.summaryDetail) return 0.00
      return round(this.dashboardDetail.summaryDetail.principleRemain, 2)
    },
    paidPrinciple(){
      if (!this.dashboardDetail || !this.dashboardDetail.summaryDetail) return 0.00
      return round(this.dashboardDetail.summaryDetail.paidPrinciple, 2)
    },
    paidPrinciplePercentage(){
      if(this.loanAmount === 0) return 0.00
      return round(this.paidPrinciple*100/this.loanAmount, 2)
    },
    lastPaymentDate(){
      if (!this.dashboardDetail || !this.dashboardDetail.summaryDetail || !this.dashboardDetail.summaryDetail.lastPayment) return "-"
      return this.dashboardDetail.summaryDetail.lastPayment.date
    },
    lastPaymentAmount(){
      if (!this.dashboardDetail || !this.dashboardDetail.summaryDetail || !this.dashboardDetail.summaryDetail.lastPayment) return 0.00
      return this.dashboardDetail.summaryDetail.lastPayment.amount
    },
    paymentAmount(){
      if(!this.paymentAmountDetailNormal) return 0.00
      return this.paymentAmountDetailNormal.amount
    },
    paymentRoundDate(){
      if( this.contract.loan && this.paymentRoundDetail){
        // let coDate = this.contract.loan.coDate
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.paymentRoundDate).format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
    validEmail(){
      return ( /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.prompt.email) ) //eslint-disable-line
    },
    validPrompt(){
      return (this.prompt.mobile.length > 0 && (this.prompt.email.length > 0) ) || !this.validEmail
    }
  },
  methods: {
    ...mapAccountingActions([
      'getContractsByCurrentUser',
      'getContract',
      'getTransactionsActionByContractId',
      'getDashboardDetailByContractId',
      'getPaymentAmountDetailByContractId',
      'getPaymentRoundDetailByContractId'
    ]),
    ...mapActions([
      'updateInformation'
    ]),
    transactionDate(res) {
      const vm = this
      return vm.$options.filters.toThaiDDMMMYYYYFormat(moment.utc(res.transactionDateTime).format("YYYY-MM-DD"))
    },
    transactionTime(res) {
      return moment.utc(res.transactionDateTime).format("HH:mm น.")
    },
    transactionType(res) {
      const vm = this
      let transactionType = ""
      if(res.transactionType === 'AddRestructuring'){
        transactionType = vm.$t('general.transactionTypes.AddRestructuring')
      }else if(res.transactionType === 'AddLoanDetail'){
        transactionType = vm.$t('general.transactionTypes.AddLoanDetail')[res.loanDetail.loanDetailType]
      }else if(res.transactionType === 'AddFeeDetail'){
        transactionType = vm.$t('general.transactionTypes.AddFeeDetail')[res.feeDetail.feeType]
      }else if(res.transactionType === 'AddPayment'){
        transactionType = vm.$t('general.transactionTypes.AddPayment')
      }
      return transactionType
    },
    amount(res) {
      let amount = 0
      if(res.transactionType === 'AddRestructuring'){
        amount = res.restructuringDetail.principleRemain
      }else if(res.transactionType === 'AddLoanDetail'){
        amount = res.loanDetail.amount
      }else if(res.transactionType === 'AddFeeDetail'){
        amount = res.feeDetail.amount
      }else if(res.transactionType === 'AddPayment'){
        amount = res.payment.paymentAmount
      }
      return amount
    },
    btnPayment () {
      this.$router.push({ name: 'paymentAndCheck-payment' })
    },
    btnMore () {
      this.$router.push({ name: 'paymentAndCheck-statementHistory' })
    },
    btnTransactionPayment (id) {
      const vm = this
      const transaction = vm.transactions.find(transaction => transaction.id === id)
      const res = paidTransactionDetail(transaction)
      vm.transactionPaymentPopup = {
        active: true,
        paidFee: res.paidFee,
        paidPenalty: res.paidPenalty,
        paidInterest: res.paidInterest,
        paidPrinciple: res.paidPrinciple,
      }
    },
    async acceptPrompt(){
      if (this.isStudentSupportReadOnly) return
      const vm = this
      await vm.updateInformation({
        form: {
          email: this.prompt.email,
          mobile:  this.prompt.mobile
        }
      })
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
};
</script>

<style>
  span.label{
    color: #8389a2
  }
  span.principleRemain{
    color: #0f4c81;
    font-size: 40px;
    font-weight: 600;
  }
  span.bold{
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }
  span.moneyUnit{
    color: #000000;
    font-size: 15px;
    font-weight: 600;
  }
  span.paidPrinciple{
    color: #32CD32;
    font-size: 40px;
    font-weight: 600;
  }
  span.paymentAmount{
    color: #0f4c81;
    font-size: 40px;
    font-weight: 600;
  }
  .con-vs-popup .vs-popup {
    width: 400px !important;
    height: auto !important;
  }

    .list-card{
    line-height: 2.3;
  }
  .list-card span.title-head {
    color: #0f4c81;
    font-size: 14px;
    font-weight: 600;
  }
  .list-card span.title-bold{
    color: #000000;
    font-size: 18px;
    font-weight: 600;
  }
  .list-card span.label{
    color: #8389a2;
    font-size: 14px;
    font-weight: 400;
  }
  .list-card span.label-bold{
    color: #000000;
    font-size: 14px;
    font-weight: 600;
  }
  .list-card hr{
      border: 0.1px solid #8389a2;
  }
</style>
